(function($) {

	var defaults = {
		scrollDelay : 5000,
		scrollSpeed : 1000,
		direction : "top",
		autoScroll : false,
		pauseOnMouse : true,
		itemsPerGroup : 1
	};

	// ------------------------------------------------------------------------
	// jQuery hook
	// ------------------------------------------------------------------------

	$.fn.rolodex = function(params, value) {
		var $list = this;
		var existing = $list.data("rolodex");

		if (existing) {
			if (typeof params === "string") {
				if (params === "next") {
					existing.scroll();
				}
				else if (params === "to") {
					existing.scroll(value);
				}
				else {
					console.warn('rolodex: unrecognized command, "' + params + '"');
				}
			}
			else {
				existing.stopAuto();
				existing.unbindEvents();
			}
		}
		else {
			params = $.extend(true, {}, defaults, params);
			var items = $list.children();

			var roll = new Rolodex($list, items, params);
			roll.init();

			$list.data("rolodex", roll);
		}
	};

	// ------------------------------------------------------------------------
	// Class definition
	// ------------------------------------------------------------------------

	var Rolodex = function($list, items, params) {
		this.$list = $list;
		this.items = items;
		this.params = params;

		this.index = 0;
		this.intervalId = null;
	};

	Rolodex.prototype.init = function() {
		if (this.params.autoScroll) {
			this.bindEvents();
			this.startAuto();
		}
	};

	Rolodex.prototype.bindEvents = function() {
		// Stop the scroll on mouse interaction
		if (this.params.pauseOnMouse) {
			this.$list.on("mouseenter", "li", $.proxy(this.stopAuto, this));
			this.$list.on("mouseleave", "li", $.proxy(this.startAuto, this));
		}
	};

	Rolodex.prototype.unbindEvents = function() {
		this.$list.off("mouseenter mouseleave", "li");
	};

	Rolodex.prototype.startAuto = function() {
		var self = this;

		this.intervalId = setTimeout(
			function() {
				self.scroll(self.index + 1);

				// Loop the timeout if we're still going
				if (self.intervalId) {
					window.clearTimeout(self.intervalId);
					self.startAuto();
				}
			},
			this.params.scrollDelay
		);
	};

	Rolodex.prototype.stopAuto = function() {
		window.clearInterval(this.intervalId);
	};

	Rolodex.prototype.scroll = function(newIndex) {
		if (newIndex === undefined || newIndex >= this.items.length) {
			newIndex = 0;
		}

		if (newIndex != this.index) {
			var $item = $(this.items[this.index]);
			var $nextItem = $(this.items[newIndex]);
			var itemHeight = $item.height();
			var direction = this.params.direction;

			if (!this.params.autoScroll) {
				direction = (this.index < newIndex) ? "top" : "bottom";
			}
			else {
				// Auto scroll will always follow the same direction
				$nextItem.css("top", itemHeight);
			}

			if (direction === "top") {
				itemHeight *= -1;
			}

			// Move the next item into position
			$nextItem.css("top", itemHeight * -1);

			// Move the first item above view
			$item.stop().animate(
				{ top : itemHeight },
				this.params.scrollSpeed,
				function() {
					// Shift the item back to the bottom
					$item.css("top", itemHeight);
				}
			);

			// Move the next item into view
			$nextItem.stop().animate(
				{ top : 0 },
				this.params.scrollSpeed
			);

			this.index = newIndex;
		}
	};

	Rolodex.prototype.getItemsInGroup = function(groupIndex) {
		var startIndex = this.params.itemsPerGroup * groupIndex;
		var endIndex = startIndex + this.params.itemsPerGroup;

		return this.items.slice(startIndex, endIndex);
	};

})(jQuery);